import { useTranslation } from "react-i18next";
import { IBreadcrumbsAndMenu } from "../../../types/global";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import HeaderLayout from "../../../components/UI/HeaderLayout";
import { Typography } from "@mui/material";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import GoodsTransferReportTable from "../../../components/Table/Inventory/Report/GoodsTransferReportTable";
import { useInventoryReport } from "../../../hooks/Inventory/use-inventory-report";
import { InventoryReportType } from "../../../generated/inventory";
import { useStateContext } from "../../../contexts/auth-context";

const GoodsTransferReport = () => {
  const { t } = useTranslation();

  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("inventory.index"),
      to: "/inventory",
    },
    {
      name: t("report"),
      to: "/inventory/report",
    },
    {
      name: t("inventory.goods_transfer.index"),
    },
  ];

  const gridRef = useRef<AgGridReact>(null);

  const { onBtnExport, isExporting, isFetching } = useInventoryReport(
    gridRef,
    InventoryReportType.GoodsTransfer
  );

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <HeaderLayout>
        <Typography variant="h5">
          {t("inventory.goods_transfer.index")}
        </Typography>
        {permissions?.inventory_export.view && (
          <CustomizedButton
            title={`${t("button.export")}`}
            variant="contained"
            onClick={onBtnExport}
            disabled={isExporting && isFetching}
          />
        )}
      </HeaderLayout>
      <GoodsTransferReportTable gridRef={gridRef} />
    </>
  );
};

export default GoodsTransferReport;
